import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificacaoDataService } from '../notificacoes/service/notificacao-data.service';

interface ManutencaoData {
  mensagem: string;
  dataExpiracao: string;
}

@Component({
  selector: 'ngx-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.scss']
})
export class MaintenanceBannerComponent implements OnInit, OnDestroy {
  private readonly codigoManutencao = 8; 
  mostrarBanner: boolean = false;
  mensagem: string = '';
  dataExpiracao: Date | null = null;
  tempoRestante: string = '';

  private subscriptions: Subscription[] = [];
  private intervalId: any;

  constructor(private notificacaoDataService: NotificacaoDataService) {}

  ngOnInit(): void {
    this.notificacaoDataService.GetNotificacoes().subscribe(
      notificacoes => {
        this.processarNotificacoes(notificacoes.data);
      }
    );

    const notificacoesSub = this.notificacaoDataService.getNotificacoesEvent().subscribe(
      result => {
        this.processarNotificacoes(result);
      }
    );

    this.subscriptions.push(notificacoesSub);

    this.intervalId = setInterval(() => {
      this.verificarExpiracao();
    }, 10000);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private processarNotificacoes(notificacoes: any[]): void {
    const notificacaoManutencao = notificacoes.find(n => {
      return n.TipoNotificacao?.Codigo === this.codigoManutencao;
    });

    if (notificacaoManutencao && notificacaoManutencao.Observacao) {
      try {
        // Parse the JSON observacao field
        const observacaoData: ManutencaoData = JSON.parse(notificacaoManutencao.Observacao);
        this.mensagem = observacaoData.mensagem;
        this.dataExpiracao = new Date(observacaoData.dataExpiracao);

        // Check if not expired
        const agora = new Date();
        if (agora < this.dataExpiracao) {
          this.mostrarBanner = true;
          this.atualizarTempoRestante();
        } else {
          this.mostrarBanner = false;
        }
      } catch (error) {
        console.error('Erro ao parsear observacao da notificação de manutenção:', error);
        this.mostrarBanner = false;
      }
    } else {
      this.mostrarBanner = false;
    }
  }

  private verificarExpiracao(): void {
    if (this.dataExpiracao) {
      const agora = new Date();
      if (agora >= this.dataExpiracao) {
        this.mostrarBanner = false;
      } else {
        this.atualizarTempoRestante();
      }
    }
  }

  private atualizarTempoRestante(): void {
    if (!this.dataExpiracao) {
      this.tempoRestante = '';
      return;
    }

    const agora = new Date();
    const diffMs = this.dataExpiracao.getTime() - agora.getTime();

    if (diffMs <= 0) {
      this.tempoRestante = '';
      return;
    }

    const horas = Math.floor(diffMs / (1000 * 60 * 60));
    const minutos = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    if (horas > 0) {
      this.tempoRestante = `Expira em ${horas}h ${minutos}min`;
    } else if (minutos > 0) {
      this.tempoRestante = `Expira em ${minutos}min`;
    } else {
      const segundos = Math.floor((diffMs % (1000 * 60)) / 1000);
      this.tempoRestante = `Expira em ${segundos}s`;
    }
  }
}
